export interface ResourceItem {
  id: number;
  title: string;
  subject: string;
  format: "网盘" | "直链" | "磁力" | "秒传";
  size: string;
  update: string;
  status: "热门" | "更新" | "整理" | "补档";
  desc: string;
  tags: string[];
  img: string;
}

export const hotResources: ResourceItem[] = [
  {
    id: 1,
    title: "2026 春季新番合集 · 全 12 部一次性收齐",
    subject: "动画",
    format: "网盘",
    size: "86.4 GB",
    update: "2026-08-17",
    status: "热门",
    desc: "精选 2026 春季开播的 12 部高热度新番，包含正片、字幕与片尾特典，网盘直链均已校验，可直接打包下载。",
    tags: ["新番", "全集", "字幕组"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20cozy%20anime-inspired%20spring%20landscape%20with%20cherry%20blossoms%20and%20soft%20sunset%20gradient%2C%20layered%20paper-cut%20geometric%20shapes%2C%20warm%20orange%20and%20pine%20green%20tones%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-anime-spring&orientation=landscape",
  },
  {
    id: 2,
    title: "人气漫画前 50 卷合集 · 无水印高清",
    subject: "漫画",
    format: "磁力",
    size: "12.3 GB",
    update: "2026-08-16",
    status: "补档",
    desc: "热销人气漫画前 50 卷高清合集，磁力链接持续做种中，附种子文件与资源树预览，方便按卷选择性下载。",
    tags: ["长篇", "高清", "无水印"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20stack%20of%20open%20manga%20books%20with%20dynamic%20ink%20patterns%2C%20paper%20texture%2C%20warm%20amber%20and%20deep%20ink%20tones%2C%20minimal%20geometric%20composition%2C%20no%20text&width=800&height=600&seq=res-manga-vol&orientation=landscape",
  },
  {
    id: 3,
    title: "复古像素独立游戏合集 · 免安装直链",
    subject: "游戏",
    format: "直链",
    size: "5.8 GB",
    update: "2026-08-15",
    status: "热门",
    desc: "收录 20 款口碑向复古像素独立游戏，解压即玩，直链带宽充足，附汉化补丁与操作说明文档。",
    tags: ["独立游戏", "免安装", "汉化"],
    img: "https://readdy.ai/api/search-image?query=Retro%20pixel%20art%20game%20controller%20illustration%20with%20neon%20grid%20and%20blocky%20landscape%2C%20flat%20vector%20style%2C%20warm%20orange%20and%20teal%20accent%20colors%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-game-pixel&orientation=landscape",
  },
  {
    id: 4,
    title: "治愈系 OST 无损音轨包 · 秒传即存",
    subject: "音乐",
    format: "秒传",
    size: "3.2 GB",
    update: "2026-08-14",
    status: "更新",
    desc: "精选治愈系动画原声无损音轨，秒传码一键转存到个人网盘，支持多种网盘秒传方式，断点续传不丢档。",
    tags: ["OST", "无损", "秒传码"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20music%20notes%20and%20headphones%20floating%20over%20a%20calm%20gradient%20background%2C%20soft%20pastel%20warm%20tones%20with%20pine%20green%20accents%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-music-ost&orientation=landscape",
  },
  {
    id: 5,
    title: "年度热血剧集合集 · 中字内嵌版",
    subject: "剧集",
    format: "网盘",
    size: "42.7 GB",
    update: "2026-08-13",
    status: "整理",
    desc: "年度热血剧集全季合集，内嵌中文字幕无需另挂，网盘多通道分流，大文件打包下载更省心。",
    tags: ["全季", "中字", "打包"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20television%20with%20dramatic%20light%20rays%20and%20film%20reel%20elements%2C%20warm%20terracotta%20and%20cream%20tones%2C%20minimal%20geometric%20composition%2C%20no%20text&width=800&height=600&seq=res-tv-drama&orientation=landscape",
  },
  {
    id: 6,
    title: "效率工具全家桶 · 直链高速分流",
    subject: "软件",
    format: "直链",
    size: "1.6 GB",
    update: "2026-08-12",
    status: "热门",
    desc: "办公效率工具全家桶整合包，直链多节点高速分流，附安装引导与激活说明，一站配齐常用软件。",
    tags: ["效率", "整合包", "高速"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20floating%20productivity%20app%20icons%20and%20toolboxes%20in%20a%20grid%2C%20warm%20sand%20background%20with%20terracotta%20and%20green%20accents%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-soft-tools&orientation=landscape",
  },
  {
    id: 7,
    title: "轻小说精校合集 · 双格式秒传",
    subject: "小说",
    format: "秒传",
    size: "890 MB",
    update: "2026-08-11",
    status: "补档",
    desc: "人气轻小说精校合集，同时提供 EPUB 与 TXT 双格式，秒传码即转即存，补全历史缺卷。",
    tags: ["精校", "EPUB", "双格式"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20open%20book%20with%20floating%20light%20particles%2C%20warm%20paper%20and%20amber%20tones%20with%20soft%20green%20accents%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=res-novel-epub&orientation=landscape",
  },
  {
    id: 8,
    title: "经典国漫典藏合集 · 网盘转存直链",
    subject: "漫画",
    format: "网盘",
    size: "18.9 GB",
    update: "2026-08-10",
    status: "整理",
    desc: "经典国漫典藏合集，网盘转存直链齐全，修复旧版失效资源，热门篇目提供打包下载入口。",
    tags: ["国漫", "典藏", "转存"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20traditional%20chinese%20ink%20landscape%20with%20paper%20scrolls%20and%20mountains%2C%20warm%20cream%20and%20terracotta%20tones%2C%20minimal%20geometric%20style%2C%20no%20text&width=800&height=600&seq=res-manhua-classic&orientation=landscape",
  },
];

export const updateResources: ResourceItem[] = [
  {
    id: 9,
    title: "夏季新番第 3 周更新 · 准时补档",
    subject: "动画",
    format: "网盘",
    size: "12.1 GB",
    update: "2026-08-18",
    status: "更新",
    desc: "夏季新番第 3 周更新批次，准时补档放送，网盘与直链均已就绪。",
    tags: ["周更", "补档"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20summer%20anime%20city%20street%20with%20sunlight%20and%20soft%20clouds%2C%20warm%20orange%20and%20cream%20tones%20with%20green%20accents%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-summer-anime&orientation=landscape",
  },
  {
    id: 10,
    title: "同人音乐企划精选 · 秒传即取",
    subject: "音乐",
    format: "秒传",
    size: "2.4 GB",
    update: "2026-08-17",
    status: "更新",
    desc: "同人音乐企划精选合集，秒传码即转即取，支持批量转存。",
    tags: ["同人", "精选"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20vinyl%20records%20and%20sound%20waves%20in%20a%20warm%20gradient%2C%20pastel%20terracotta%20and%20teal%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=res-doujin-music&orientation=landscape",
  },
  {
    id: 11,
    title: "热门漫画补档 · 前 20 卷重制",
    subject: "漫画",
    format: "磁力",
    size: "4.1 GB",
    update: "2026-08-16",
    status: "补档",
    desc: "热门漫画前 20 卷重制补档，画质修复，磁力持续做种。",
    tags: ["补档", "重制"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20open%20manga%20pages%20with%20scanner%20grid%20and%20ink%20patterns%2C%20warm%20amber%20and%20deep%20ink%20tones%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-manga-rescan&orientation=landscape",
  },
  {
    id: 12,
    title: "独立游戏新作直链 · 尝鲜包",
    subject: "游戏",
    format: "直链",
    size: "820 MB",
    update: "2026-08-15",
    status: "热门",
    desc: "独立游戏新作尝鲜包，直链高速下载，附试玩反馈表。",
    tags: ["新作", "尝鲜"],
    img: "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20game%20console%20with%20glowing%20joystick%20and%20abstract%20blocky%20world%2C%20warm%20terracotta%20and%20teal%20tones%2C%20minimal%2C%20no%20text&width=800&height=600&seq=res-game-new&orientation=landscape",
  },
];

export const ways = [
  {
    key: "网盘",
    icon: "ri-cloud-line",
    title: "网盘转存",
    desc: "一键转存到个人网盘，支持批量打包，适合大文件长期保存与分享。",
    tone: "primary",
  },
  {
    key: "直链",
    icon: "ri-link-m",
    title: "直链下载",
    desc: "多节点高速直链，浏览器直接下载，免客户端，速度稳定可靠。",
    tone: "accent",
  },
  {
    key: "磁力",
    icon: "ri-attachment-line",
    title: "磁力链接",
    desc: "标准磁力链接持续做种，配合下载工具使用，适合追更补档。",
    tone: "secondary",
  },
  {
    key: "秒传",
    icon: "ri-flashlight-line",
    title: "秒传码",
    desc: "生成秒传码一键转存，断点续传不丢档，多网盘通用更省心。",
    tone: "accent",
  },
];

export const categories = [
  { name: "动画", icon: "ri-film-line", count: 128 },
  { name: "漫画", icon: "ri-book-open-line", count: 96 },
  { name: "游戏", icon: "ri-gamepad-line", count: 74 },
  { name: "音乐", icon: "ri-music-2-line", count: 65 },
  { name: "剧集", icon: "ri-tv-line", count: 48 },
  { name: "软件", icon: "ri-apps-line", count: 57 },
  { name: "小说", icon: "ri-quill-pen-line", count: 83 },
  { name: "合集", icon: "ri-archive-drawer-line", count: 39 },
];

export const faqs = [
  {
    q: "为什么有的资源链接会失效？",
    a: "资源链接的存活与网盘方或做种环境有关，属于正常现象。你可以优先选择带「有效」标记的资源，或切换网盘/直链/磁力/秒传等不同获取方式重新尝试。热门资源我们会定期补档修复。",
  },
  {
    q: "按格式筛选到底怎么用？",
    a: "每个资源都会标注可用的获取方式（网盘、直链、磁力、秒传）。你只需在顶部按自己方便的方式筛选，就能只看对应格式的资源，不用挨个帖子试失效链接。",
  },
  {
    q: "「打包下载」和普通下载有什么区别？",
    a: "打包下载是把多个分卷或合集一次性整理成压缩包，适合想一次性收齐的宅友，转存后一次解压即可，比逐条下载更省心省时。",
  },
  {
    q: "磁力链接一直没速度怎么办？",
    a: "磁力链接依赖做种人数。若长时间无速度，可尝试换个端口、挂机等待做种回升，或直接改用该资源的网盘 / 直链 / 秒传版本，通常都能顺利下载。",
  },
  {
    q: "秒传码转存失败该如何处理？",
    a: "秒传码需要对应网盘客户端支持，请确认你的网盘与秒传码生成方一致，并检查是否已登录。仍失败可联系补档入口，我们会在核对后更新可用的秒传码。",
  },
  {
    q: "如何及时获取追更和补档提醒？",
    a: "把关注的资源加入收藏，最新更新与补档信息会在「最新更新」板块第一时间同步，你也可以通过页脚联系方式反馈想追更的清单。",
  },
];